import { Controller } from "stimulus"
import SlimSelect from "slim-select"

export default class extends Controller {
  static targets = [ "select" ]
  static values = { childId: String, eventFormatVenues: Array, eventFormatDefaults: Array }

  connect() {
    if (this.hasSelectTarget) {
      this.slim = new SlimSelect({
        select: this.selectTarget
      })
      // console.log("Loaded EventFormat venues:", this.eventFormatVenuesValue)
      // console.log("Loaded EventFormat venues:", this.eventFormatDefaultsValue)
    }
  }

  disconnect() {
    if (this.slim) {
      this.slim.destroy()
    }
  }

  venueChanged(event) {
    const selectedValue = event.target.value
    const selectedOption = this.selectTarget.selectedOptions[0]

    const venue = selectedOption.dataset.address
    if (venue) {
      document.getElementById('event_venue').value = venue
    } else {
      document.getElementById('event_venue').value = ""
    }

    const mapLink = selectedOption.dataset.mapLink
    if (mapLink) {
      document.getElementById('event_map_link').value = mapLink
    } else {
      document.getElementById('event_map_link').value = ""
    }

    const startHour = selectedOption.dataset.startHour
    if (startHour) {
      document.getElementById('event_start_date_4i').value = startHour
    } else {
      document.getElementById('event_start_date_4i').value = "18"
    }

    const endHour = selectedOption.dataset.endHour
    if (endHour) {
      document.getElementById('event_end_date_4i').value = endHour
    } else {
      document.getElementById('event_end_date_4i').value = "20"
    }

    const startMin = selectedOption.dataset.startMin
    if (startMin) {
      document.getElementById('event_start_date_5i').value = startMin
    } else {
      document.getElementById('event_start_date_5i').value = "00"
    }

    const endMin = selectedOption.dataset.endMin
    if (endMin) {
      document.getElementById('event_end_date_5i').value = endMin
    } else {
      document.getElementById('event_end_date_5i').value = "00"
    }
  }

  updateVenueFields(event_format_venue) {
    const venue = event_format_venue.venue
    const selectElement = document.getElementById('event_event_venue_id')
    selectElement.slim.setSelected(venue.id)
    // selectElement.dispatchEvent(changeEvent);

    const address = venue.address
    if (address) {
      document.getElementById('event_venue').value = address
    } else {
      document.getElementById('event_venue').value = ""
    }

    const mapLink = venue.map_link
    if (mapLink) {
      document.getElementById('event_map_link').value = mapLink
    } else {
      document.getElementById('event_map_link').value = ""
    }

    const startHour = event_format_venue.start_hour
    if (startHour) {
      document.getElementById('event_start_date_4i').value = startHour
    } else {
      document.getElementById('event_start_date_4i').value = "18"
    }

    const endHour = event_format_venue.end_hour
    if (endHour) {
      document.getElementById('event_end_date_4i').value = endHour
    } else {
      document.getElementById('event_end_date_4i').value = "20"
    }

    const startMin = event_format_venue.start_min
    if (startMin) {
      document.getElementById('event_start_date_5i').value = startMin
    } else {
      document.getElementById('event_start_date_5i').value = "00"
    }

    const endMin = event_format_venue.end_min
    if (endMin) {
      document.getElementById('event_end_date_5i').value = endMin
    } else {
      document.getElementById('event_end_date_5i').value = "00"
    }
  }

  cityParentChanged(event) {
    const selectedValue = event.target.value
    const selectedOption = this.selectTarget.selectedOptions[0]
    const venueId = selectedOption.dataset.venueId
    const timeZone = selectedOption.dataset.timeZone

    if (timeZone) {
      document.getElementById('event_time_zone').slim.setSelected(timeZone)
    }

    // Dispatch custom event
    const customEvent = new CustomEvent('city-parent-select-changed', {
      detail: { 
        venueId: venueId,
        childId: this.childIdValue 
      }
    })

    window.dispatchEvent(customEvent)
  }

  handleFormatChange(event) {
    const citySelect = document.getElementById('event_city_ids')
    const cityId = citySelect.value
    const cityName = citySelect.options[citySelect.selectedIndex].text

    const yearSelect = document.getElementById('event_start_date_1i')
    const year = yearSelect.options[yearSelect.selectedIndex].text

    const monthSelect = document.getElementById('event_start_date_2i')
    const month = monthSelect.options[monthSelect.selectedIndex].text

    const daySelect = document.getElementById('event_start_date_3i')
    const day = daySelect.options[daySelect.selectedIndex].text

    const date = new Date(`${year}-${month}-${day}`);

    const event_format_venue =  this.findByEventFormatAndCity(parseInt(event.target.value), parseInt(cityId))
    if (event_format_venue) {
      this.updateVenueFields(event_format_venue)
    } else if (cityId) {
      citySelect.slim.setSelected(cityId)
      citySelect.dispatchEvent(new Event('change'));
    }

    let eventFormatId = event.target.value

    if (eventFormatId) {
      eventFormatId = parseInt(eventFormatId)

      const ev = this.eventFormatDefaultsValue.find(v =>
        v.id === eventFormatId
      )

      if (ev) {
        let title = ev.event_title_format
        let description = ev.event_description_format

        if (cityId) {
          title = title.replace(/\*\|city_name\|\*/g, cityName)
        }

        if (monthSelect.value) {
          title = title.replace(/\*\|month_name\|\*/g, month)
        }

        if (daySelect.value) {
          const options = {
            weekday: "short",     // "Wed"
            day: "2-digit",       // "04"
            month: "long",        // "June"
            year: "numeric"       // "2025"
          };
          const formattedDate = date.toLocaleDateString("en-US", options);

          description = description.replace(/\*\|city_name\|\*/g, cityName)
          description = description.replace(/\*\|date_with_weekday\|\*/g, formattedDate)
        }

        document.getElementById('event_title').value = title
        document.getElementById('event_short_description_trix').value = description
        document.getElementById('event_unlisted_note_trix').value = ev.unlisted_note
 document.getElementById('event_tickets_for').slim.setSelected(ev.tickets_for)
      }
    }
  }

  handleCityParentChange(event) {
    const { venueId, childId } = event.detail

    // Only respond if this is the intended child
    if (childId && this.element.id !== childId) return

    if (venueId) {
      this.slim.setSelected(venueId)
    } else {
      this.slim.setSelected("")
    }
  }

  // Return ALL matches for a given city_id
  findByCity(cityId) {
    return this.eventFormatVenuesValue.filter(v => v.city_id === cityId)
  }

  // Optional: Return matches for selected event format and city
  findByEventFormatAndCity(eventFormatId, cityId) {
    const matches = this.eventFormatVenuesValue.filter(v =>
      v.event_format_id === eventFormatId && v.city_id === cityId
    )

    if (matches.length > 0) {
      const defaultMatch = matches.find(v => v.default === true)
      return defaultMatch ? defaultMatch : matches[0]
    } else {
      return false
    }
  }
}
